module.exports = __webpack_public_path__ + "img/_4.accb2a4d.png";